import React from 'react';
import { Button } from '../../../../../../base/components/Button';
import { PasswordInput } from '../../../../../../base/components/Forms/PasswordInput';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { passwordRecoveryActions } from '../../../redux/slices/passwordRecoverySlice';

export const SetNewPassword = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { password },
        errors,
    } = useAppSelector((state) => state.workerAppPasswordRecovery);

    const inputChangeHandler = (id: string, value: unknown) => {
        dispatch(passwordRecoveryActions.setField({ id, value }));
    };

    const setNewPasswordSubmitHandler = () => dispatch(passwordRecoveryActions.submitSetNewPassword());

    return (
        <div className='password-recovery'>
            <div className='password-recovery__form-item scroll-margin-for-fixed-header'>
                <p className='password-recovery__form-label'>{__t('Новый пароль')}</p>
                <PasswordInput
                    value={password}
                    placeholder={__t('Минимум 6 символов')}
                    onChange={(value: string) => inputChangeHandler('password', value)}
                    errors={errors?.password}
                />
            </div>
            <Button className='password-recovery__button' onClick={setNewPasswordSubmitHandler}>
                {__t('Сохранить')}
            </Button>
        </div>
    );
};
